import React from 'react';
import PropTypes from 'prop-types';
import FavoriteFilledIcon from '@mui/icons-material/Favorite';
import FavoriteOutlineIcon from '@mui/icons-material/FavoriteBorder';

// The heart every favorite control draws. Size comes from the caller.
export default function FavoriteIcon({ isFavorite, size }) {
  const sx = { fontSize: size, color: isFavorite ? 'primary.main' : '#3c3c3c' };
  return isFavorite ? <FavoriteFilledIcon sx={sx} /> : <FavoriteOutlineIcon sx={sx} />;
}

export function favoriteActionTitle(isFavorite) {
  return isFavorite ? 'Favorite — click to clear' : 'Favorite';
}

FavoriteIcon.propTypes = {
  isFavorite: PropTypes.bool,
  size: PropTypes.number,
};

FavoriteIcon.defaultProps = {
  isFavorite: false,
  size: 20,
};
